import { Box, Typography } from '@mui/material';
import React from 'react';

import { RecordType } from 'shared/components/internal/Records';
import { type EntityTypeFieldsAndIndicator } from 'shared/components/internal/Records/useEntityTypeRecordFields';

import { RecordProperty } from '../RecordProperty';
import { useMappingFields } from './useMappingFields';

interface MappingProps {
  allRecordData: RecordType;
  data: RecordType;
  showEmpty: boolean;
  entityTypeFieldsAndIndicator?: EntityTypeFieldsAndIndicator;
}

export const Mapping = ({
  allRecordData,
  data,
  showEmpty,
  entityTypeFieldsAndIndicator,
}: MappingProps) => {
  const fields = useMappingFields(data, showEmpty);

  return (
    <Box flex={1} position='relative'>
      <Typography variant='h2' mb={1}>
        Mapping
      </Typography>
      <Box sx={{ columnWidth: '200px' }}>
        {fields.map(({ name, label, value }) => (
          <Box key={`record-prop-${name}`} sx={{ breakInside: 'avoid-column' }}>
            <RecordProperty
              entityTypeFieldsAndIndicator={entityTypeFieldsAndIndicator}
              label={label}
              name={name}
              record={allRecordData}
            >
              {value}
            </RecordProperty>
          </Box>
        ))}
      </Box>
    </Box>
  );
};
